





































import Vue from 'vue'
import NavTooltip from '@/components/userProfile/NavTooltip.vue'
import Achievement from '@/assets/svgs/achievement_icon.svg?inline'
import AccountCircle from '@/assets/svgs/account_circle.svg?inline'
import DropdownArrow from '@/assets/svgs/dropdown_arrow.svg?inline'
import ID from '@/assets/svgs/id_icon.svg?inline'
import Lock from '@/assets/svgs/lock_icon.svg?inline'
import Settings from '@/assets/svgs/settings_icon.svg?inline'
import Target from '@/assets/svgs/target_icon.svg?inline'
import VerifiedUser from '@/assets/svgs/verified_user_icon.svg?inline'
import Visibility from '@/assets/svgs/visibility_icon.svg?inline'
import Work from '@/assets/svgs/work_icon.svg?inline'
import variables from '@/scss/variables.scss'

interface Data {
  showNav: boolean
  canToggleNav: boolean
}

interface Methods {
  handleResize: () => void
}

interface Computed {}

interface Props {}

const LINKS = [
  {
    type: 'section',
    icon: 'AccountCircle',
    labeli18n: 'profile',
  },
  {
    type: 'link',
    icon: 'ID',
    labeli18n: 'personalInfo',
    linkProps: {
      exact: true,
      to: '/',
      id: 'profile-link',
    },
  },
  {
    type: 'link',
    icon: 'Work',
    labeli18n: 'workeducation',
    linkProps: {
      to: '/workeducation',
      id: 'work-ed-link',
    },
  },
  {
    type: 'link',
    icon: 'Target',
    labeli18n: 'career',
    linkProps: {
      to: '/career',
      id: 'career-link',
    },
  },
  {
    type: 'link',
    icon: 'Achievement',
    labeli18n: 'achievement',
    linkProps: {
      to: '/achievement',
      id: 'achievement-link',
    },
    temporarilyDisabled: true,
    tooltipTexti18n: 'manageYourAchievements',
  },
  {
    type: 'section',
    icon: 'Settings',
    labeli18n: 'settings',
    temporarilyDisabled: true,
  },
  {
    type: 'link',
    icon: 'VerifiedUser',
    labeli18n: 'security',
    linkProps: {
      to: '/security',
      id: 'security-link',
    },
    temporarilyDisabled: true,
    tooltipTexti18n: 'manageYourPassword',
  },
  {
    type: 'link',
    icon: 'Lock',
    labeli18n: 'dataPrivacy',
    linkProps: {
      to: '/privacy',
      id: 'privacy-link',
    },
    temporarilyDisabled: true,
    tooltipTexti18n: 'manageYourDataPrivacy',
  },
]

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'Navigation',
  data: function () {
    return {
      showNav: false,
      canToggleNav: true,
      links: LINKS.map(link => link.linkProps
        ? { ...link, linkProps: { ...link.linkProps, to: { path: `${this.$props.parentRoute}${link.linkProps.to}`, query: this.$route.query } } }
        : link
      ),
    }
  },
  props: {
    parentRoute: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleResize: function () {
      this.showNav = false
      this.canToggleNav = window.innerWidth < variables.lg
    },
  },
  components: {
    NavTooltip,
    Achievement,
    AccountCircle,
    DropdownArrow,
    ID,
    Lock,
    Settings,
    Target,
    VerifiedUser,
    Visibility,
    Work,
  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('orientationchange', this.handleResize)
    this.handleResize()
  },
})
